import { useTranslation } from 'libs/i18n'

import { HistoryTable } from 'shared/components'
import { Header } from 'shared/components'
import { useFetchTagHistory } from './queries/useFetchTagHistory'

const TagHistoryPage = () => {
	const { t } = useTranslation()
	const { tagHistory, isLoadingHistory } = useFetchTagHistory()

	return (
		<>
			<Header title={t('Tag / History')} />
			<HistoryTable results={tagHistory?.data} isLoading={isLoadingHistory} />
		</>
	)
}

export default TagHistoryPage
